import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../MyPage.js";
import SubTabsWarehouses from "../../SubTabsWarehouses.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';
  export default class WarehousesPurchasesPoDealay extends Component{ 

    constructor(props){
      super(props);

      this.state={
          purchases:[],
          modalTitle:"",
          purchaseid:0,
          itempurchasedid_id:0,
          sapcode:"",
          itempurchasedname:"",
          poalert: "",
          povalidated: true,
          warehouseid: 0,
          yearid: 0,
          productid:0,
          july:"",
          august:"",
          september:"",
          october: "",
          november: "",
          december: "",
          january: "",
          february: "",
          march: "",
          april: "",
          may: "",
          june:"",
          comment:"",

          year: {
            yearid: 0,
            fyname: "",
            isactive: false
          },
          warehouse: {
            warehouseid: 6,
            warehousename: "",
            covertime:"",
          },
          purchasetype: {
            purchasetypeid: 0,
            purchasetypename: ""
          },

          povalidatedjuly: false,
		  povalidatedaugust: false,
		  povalidatedseptember: false,
		  povalidatedoctober: false,
		  povalidatednovember: false,
		  povalidateddecember: false,
		  povalidatedjanuary: false,
		  povalidatedfebruary: false,
		  povalidatedmarch: false,
		  povalidatedapril: false,
		  povalidatedmay: false,
		  povalidatedjune: false,
    
          CountryNameFilter:"",
          WarehouseNameFilter:"",
          FiscalYearFilter:"",
          ProductDescriptionFilter:"",
          PurchaseIdFilter:"",
          ItempurchasedIDFilter:"",
          ItempurchasedNameFilter:"",
          PurchasetypeNameFilter:"",
          CurrentYearFilter:"",
          PurchaseCommentFilter:"",
          purchasesWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          fiscalYears: [],
          items: [], 
          productdescriptions: [],
          containerdescriptions: [],
          purchasetypeNames: [],
          warehouseNames: [],
          loading: true,
          currentYearIndex: 0,
          currentYear: null,


          stockprocurement:[],
         
          stockviewid:0,
          fyname_o:"",
          regionname_o:"",
          warehousename_o:"",
          productid_o:0,
          sapcode_o:"",
          productdescription_o:"",
          itemtypename_o:"",
          july_o:"",
          august_o:"",
          september_o:"",
          october_o: "",
          november_o: "",
          december_o: "",
          january_o: "",
          february_o: "",
          march_o: "",
          april_o: "",
          may_o: "",
          june_o:"",
          stockprocurementWithoutFilter:[],
          isEditClicked: false,
          StockViewIdFilter:"",
          FiscalYearOFilter:"",
          RegionNameOFilter:"",
          WarehouseNameOFilter:"",
          ProductIdOFilter:"",
          ProductDescriptionOFilter:"",
          ItemTypeNameOFilter:"",
          fiscalYear:"",
          fiscalMonth:"",
          purchasedContainers : [],
          SapcodeNames:[],
          SapcodeDescriptionNames:[],
          containerIDs:[],
          containerDescriptionNames:[],
          palletIDs:[],
          palletDescriptionNames:[],

          myproduct:"",

          palletpodelayid: 0,
          palletpodelay: "",
          palletpodelayids: [],
          palletpodelays:[]

          
      }
  }

  getCurrentFinancialYearAndMonth() {
    const today = new Date();
    let fiscalYear = "";
    let fiscalMonth = "";
  
    // Determine fiscal year
    if ((today.getMonth() + 1) <= 6) {
      fiscalYear = (today.getFullYear());
    } else {
      fiscalYear = today.getFullYear() + 1;
    }
  
    // Determine fiscal month
    fiscalMonth = (today.getMonth() + 1); // Adding 1 as months are 0-indexed
  
    return {
      fiscalYear: fiscalYear,
      fiscalMonth: fiscalMonth
    };
  }


  
calculateDateFromFiscal(fiscalYear, fiscalMonth, leadTime) {

  // Convert fiscalYear to integer
  fiscalYear = parseInt(fiscalYear);
  // Subtract lead time from fiscal month
  let adjustedFiscalMonth = fiscalMonth - leadTime;
  adjustedFiscalMonth = Math.ceil(adjustedFiscalMonth); // Round up to the nearest integer

  // fiscal month between january and june
  if (adjustedFiscalMonth >= 1 && fiscalMonth <=6) {
      adjustedFiscalMonth = adjustedFiscalMonth;
      fiscalYear = fiscalYear;
      ;
  }

  // fiscal month between january and june
  if (adjustedFiscalMonth < 1 && fiscalMonth <=6) {
    adjustedFiscalMonth += 12;
    fiscalYear--;
    ;
}

   // fiscal month between july and december
   if (adjustedFiscalMonth > 1 && fiscalMonth >=7) {
    adjustedFiscalMonth = adjustedFiscalMonth;
    fiscalYear--;
    ;
}

 // fiscal month between july and december
 if (adjustedFiscalMonth < 1 && fiscalMonth >=7) {
  adjustedFiscalMonth += 12 ;
  fiscalYear--;
  fiscalYear--;
  ;
}

  if (adjustedFiscalMonth < 1 && leadTime > 12) {
    adjustedFiscalMonth += 12;
    fiscalYear= fiscalYear - 2 ;
    ;
}

  // Determine calendar month and year
  let calendarMonth = adjustedFiscalMonth;
  let calendarYear = fiscalYear;

  // Adjust calendar year if the month is greater than 12
  if (calendarMonth > 12) {
      calendarMonth -= 12;
      calendarYear++;
  }

  // Return the calculated date
  return {
      year: calendarYear,
      month: calendarMonth
  };
}


formatCalculatedDate(calculatedDate) {
  // Format the date with day 28
  return `${calculatedDate.month}/${calculatedDate.year}`;
}


compareDates(date1, date2) {
    // Split the dates into month and year components
    const [month1, year1] = date1.split('/');
    const [month2, year2] = date2.split('/');

    // Convert month and year strings to numbers for comparison
    const monthNum1 = parseInt(month1, 10);
    const yearNum1 = parseInt(year1, 10);
    const monthNum2 = parseInt(month2, 10);
    const yearNum2 = parseInt(year2, 10);

    // Compare years first
    if (yearNum1 > yearNum2) {
        return 1; // date1 is later than date2
    } else if (yearNum1 < yearNum2) {
        return -1; // date1 is earlier than date2
    } else {
        // If years are equal, compare months
        if (monthNum1 > monthNum2) {
            return 1; // date1 is later than date2
        } else if (monthNum1 < monthNum2) {
            return -1; // date1 is earlier than date2
        } else {
            return 0; // Both dates are equal
        }
    }
}




  handleRefresh = async () => {
    try {
        const response = await axiosService.post('/run-refresh-views/');
        console.log(response.data.message);
        // You might want to update the state or perform other actions here after refreshing
    } catch (error) {
        console.error('Error refreshing materialized views:', error);
    }
};

  FilterFn(){
    var CountryNameFilter = this.state.CountryNameFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
    var PurchaseIdFilter = this.state.PurchaseIdFilter;
    var ItempurchasedIDFilter = this.state.ItempurchasedIDFilter;
    var ItempurchasedNameFilter = this.state.ItempurchasedNameFilter;
    var PurchasetypeNameFilter = this.state.PurchasetypeNameFilter;
    var CurrentYearFilter = this.state.CurrentYearFilter;
    var PurchaseCommentFilter = this.state.PurchaseCommentFilter;

    var filteredData=this.state.purchasesWithoutFilter.filter(
        function(el){
            return el.warehouse.warehousename.toString().toLowerCase().includes(
                WarehouseNameFilter.toString().trim().toLowerCase()
            )&&  
                el.year.fyname.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.purchaseid.toString().toLowerCase().includes(
                PurchaseIdFilter.toString().trim().toLowerCase()
            )&&  
            el.sapcode.toString().toLowerCase().includes(
              ItempurchasedIDFilter.toString().trim().toLowerCase()
        )&&  
            el.itempurchasedname.toString().toLowerCase().includes(
              ItempurchasedNameFilter.toString().trim().toLowerCase()
        )&&  
        el.purchasetype.purchasetypename.toString().toLowerCase().includes(
          PurchasetypeNameFilter.toString().trim().toLowerCase()
    )&&  
        el.purchasetype.purchasetypename.toString().toLowerCase().includes(
          PurchasetypeNameFilter.toString().trim().toLowerCase()
    )
        }
    );

    this.setState({purchases:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.purchasesWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({purchases:sortedData});

}


FilterFnO(){
  var RegionNameOFilter = this.state.RegionNameOFilter;
  var WarehouseNameOFilter = this.state.WarehouseNameOFilter;
  var FiscalYearOFilter = this.state.FiscalYearOFilter;
  var ProductDescriptionOFilter = this.state.ProductDescriptionOFilter;
  var StockViewIdFilter = this.state.StockViewIdFilter;
  var ItemTypeName0Filter = this.state.ItemTypeNameOFilter;
  var ProductIdOFilter = this.state.ProductIdOFilter;


  var filteredData=this.state.stockprocurementWithoutFilter.filter(
      function(el){
          return el.warehousename_o.toString().toLowerCase().includes(
              WarehouseNameOFilter.toString().trim().toLowerCase()
          )&&  
              el.fyname_o.toString().toLowerCase().includes(
              FiscalYearOFilter.toString().trim().toLowerCase()
          )&&  
              el.stockviewid.toString().toLowerCase().includes(
              StockViewIdFilter.toString().trim().toLowerCase()
          )&&  
          el.regionname_o.toString().toLowerCase().includes(
            RegionNameOFilter.toString().trim().toLowerCase()
      )&&  
      el.productdescription_o.toString().toLowerCase().includes(
        ProductDescriptionOFilter.toString().trim().toLowerCase()
  )&&  
  el.itemtypename_o.toString().toLowerCase().includes(
    ItemTypeName0Filter.toString().trim().toLowerCase()
)&&  
el.sapcode_o.toString().toLowerCase().includes(
  ProductIdOFilter.toString().trim().toLowerCase()
)
      }
  );

  this.setState({stockprocurement:filteredData});

}

sortResultO(prop,asc){
var sortedData=this.state.stockprocurementWithoutFilter.sort(function(a,b){
    if(asc){
        return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
    }
    else{
        return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
    }
});

this.setState({stockprocurement:sortedData});

}


changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}

changeWarehouseNameFilter = (e)=>{
    this.state.WarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }

  changeItempurchasedIDFilter = (e)=>{
    this.state.ItempurchasedIDFilter=e.target.value;
    this.FilterFn();
  }


  changeItempurchasedNameFilter = (e)=>{
    this.state.ItempurchasedNameFilter=e.target.value;
    this.FilterFn();
  }

  changePurchaseTypeNameFilter = (e)=>{
    this.state.PurchasetypeNameFilter=e.target.value;
    this.FilterFn();
  }


changePurchaseIdFilter = (e)=>{
    this.state.PurchaseIdFilter=e.target.value;
    this.FilterFn();
  }

  changeCurrentYearFilter = (e)=>{
    this.state.CurrentYearFilter=e.target.value;
    this.FilterFn();
  }



  changeWarehouseNameOFilter = (e)=>{
    this.state.WarehouseNameOFilter=e.target.value;
    this.FilterFnO();
  }

  changeRegionNameOFilter = (e)=>{
    this.state.RegionNameOFilter=e.target.value;
    this.FilterFnO();
  }

  changeFiscalYearOFilter = (e)=>{
    this.state.FiscalYearOFilter=e.target.value;
    this.FilterFnO();
  }

  changeItemTypeNameOFilter = (e)=>{
    this.state.ItemTypeNameOFilter=e.target.value;
    this.FilterFnO();
  }

  changeProductDescriptionOFilter = (e)=>{
    this.state.ProductDescriptionOFilter=e.target.value;
    this.FilterFnO();
  }

  
  changeProductIdOFilter = (e)=>{
    this.state.ProductIdOFilter=e.target.value;
    this.FilterFnO();
  }

  changeStockViewIdFilter = (e)=>{
    this.state.StockViewIdFilter=e.target.value;
    this.FilterFnO();
  }

refreshList = () => {
    axiosService.get('/purchases/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ purchases: data, purchasesWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };


  refreshListProcurement = () => {
    axiosService.get('/stockprocurement/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ stockprocurement: data, stockprocurementWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };


fetchRegionNames() {
  axiosService.get('/regionnames/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const regionNames = data.map(item => item.regionname);
      this.setState({ regionNames: regionNames });
    })
    .catch(error => {
      console.error("Error fetching region names:", error);
    });
}


fetchCountryNames() {
  axiosService.get('/countries/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const countryNames = data.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}

fetchFiscalYears() {
    axiosService.get('/years/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const fiscalYears = filteredData.map(item => item.fyname);
        this.setState({ fiscalYears: fiscalYears });
      })
      .catch(error => {
        console.error("Error fetching fiscal years:", error);
      });
  }

  fetchPurchasedContainers() {
    axiosService.get('/purchases/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const { fiscalYear, fiscalMonth } = this.getCurrentFinancialYearAndMonth();
        const selectedFiscalYear = parseInt(this.state.fyname, 10);
        const selectedMonthIsJuly = parseInt(7, 10);
        const selectedMonthIsAugust = parseInt(8, 10);
        const selectedMonthIsSeptember = parseInt(9, 10);
        const selectedMonthIsOctober = parseInt(10, 10);
        const selectedMonthIsNovember = parseInt(11, 10);
        const selectedMonthIsDecember = parseInt(12, 10);
      
        const selectedMonthIsJanuary = parseInt(1, 10);
        const selectedMonthIsFebruary = parseInt(2, 10);
        const selectedMonthIsMarch = parseInt(3, 10);
        const selectedMonthIsApril = parseInt(4, 10);
        const selectedMonthIsMay = parseInt(5, 10);
        const selectedMonthIsJune = parseInt(6, 10);
      
        const isBetweenJulyAndDecember =
        fiscalMonth >= 7 && fiscalMonth <= 12; // Check if fiscal month is between July (6) and November (11) inclusive
        const isBetweenJanuaryAndJune =
        fiscalMonth >= 1 && fiscalMonth <= 6;
    
        const isPassedMonthJuly = fiscalMonth > selectedMonthIsJuly;
        const isDisabledMonthJuly2 =  isBetweenJulyAndDecember && isPassedMonthJuly;
        const isPassedMonthAugust = fiscalMonth > selectedMonthIsAugust;
        const isDisabledMonthAugust2 = isBetweenJulyAndDecember && isPassedMonthAugust;
        const isPassedMonthSeptember = fiscalMonth > selectedMonthIsSeptember;
        const isDisabledMonthSeptember2 = isBetweenJulyAndDecember && isPassedMonthSeptember ;
        const isPassedMonthOctober = fiscalMonth > selectedMonthIsOctober;
        const isDisabledMonthOctober2 =isBetweenJulyAndDecember && isPassedMonthOctober;
        const isPassedMonthNovember = fiscalMonth > selectedMonthIsNovember;
        const isDisabledMonthNovember2 = isBetweenJulyAndDecember && isPassedMonthNovember;
        const isPassedMonthDecember =  selectedMonthIsDecember && isBetweenJanuaryAndJune ;
        const isDisabledMonthDecember2 = isBetweenJulyAndDecember && isPassedMonthDecember;
      
        const isPassedMonthJanuary = fiscalMonth > selectedMonthIsJanuary;
        const isDisabledMonthJanuary2 = isBetweenJanuaryAndJune && isPassedMonthJanuary;
        const isPassedMonthFebruary = fiscalMonth > selectedMonthIsFebruary;
        const isDisabledMonthFebruary2 =  isBetweenJanuaryAndJune && isPassedMonthFebruary;
        const isPassedMonthMarch = fiscalMonth > selectedMonthIsMarch;
        const isDisabledMonthMarch2 =  isBetweenJanuaryAndJune && isPassedMonthMarch;
        const isPassedMonthApril = fiscalMonth > selectedMonthIsApril;
        const isDisabledMonthApril2 =   isBetweenJanuaryAndJune && isPassedMonthApril;
        const isPassedMonthMay = fiscalMonth > selectedMonthIsMay;
        const isDisabledMonthMay2 =  isBetweenJanuaryAndJune && isPassedMonthMay;
        const isPassedMonthJune =  selectedMonthIsJune && isBetweenJulyAndDecember ;
        const isDisabledMonthJune2 =  isBetweenJanuaryAndJune && isPassedMonthJune;


        let newFilteredData = []; 
        const filteredContainersPurchasedPastyear = data.filter(item => item.purchasetypeid === 1 && item.year.fyname < fiscalYear && 
          (item.july !== null || item.august !== null  ||  item.september !== null
            || item.october !== null  ||  item.november !== null  
            ||  item.december !== null ||  item.january !== null 
            ||  item.february !== null  ||  item.march !== null 
            ||  item.april !== null  ||  item.may !== null 
            ||  item.june !== null)) ;
        const filteredPurchasedCurrentYearJuly = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.july !== null && isDisabledMonthJuly2 );
        const filteredPurchasedCurrentYearAgust = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.august !== null && isDisabledMonthAugust2);
        const filteredPurchasedCurrentYearSeptember = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.september !== null && isDisabledMonthSeptember2 );
        const filteredPurchasedCurrentYearOctober = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.october !== null && isDisabledMonthOctober2 );
        const filteredPurchasedCurrentYearNovember = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.november !== null && isDisabledMonthNovember2 ) ;
        const filteredPurchasedCurrentYearDecember = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.december !== null && isDisabledMonthDecember2 ) ;
        const filteredPurchasedCurrentYearJanuary = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.january !== null && isDisabledMonthJanuary2 ) ;
        const filteredPurchasedCurrentYearFebruary = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.february !== null && isDisabledMonthFebruary2 ) ;
        const filteredPurchasedCurrentYearMarch = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.march !== null && isDisabledMonthMarch2 ) ;
        const filteredPurchasedCurrentYearApril = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.april !== null && isDisabledMonthApril2 ) ;
        const filteredPurchasedCurrentYearMay = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.may !== null && isDisabledMonthMay2 ) ;
        const filteredPurchasedCurrentYearJune = data.filter(item => item.purchasetypeid === 1 && item.year.fyname === fiscalYear && item.june !== null && isDisabledMonthJune2 ) ;
        newFilteredData = newFilteredData.concat(filteredPurchasedCurrentYearJuly,filteredPurchasedCurrentYearAgust,filteredPurchasedCurrentYearSeptember,filteredPurchasedCurrentYearOctober,
          filteredPurchasedCurrentYearNovember,filteredPurchasedCurrentYearDecember,filteredPurchasedCurrentYearJanuary,filteredPurchasedCurrentYearFebruary,
          filteredPurchasedCurrentYearMarch,filteredPurchasedCurrentYearApril,filteredPurchasedCurrentYearMay,filteredPurchasedCurrentYearJune);
        //const fiscalYears = newFilteredData.map(item => item.itempurchasedid_id);

        // Create a set to keep unique values
      const uniqueItemIdsSet = new Set(newFilteredData.map(item => item.itempurchasedid_id));
      
      // Convert the set back to an array
      const uniqueItemIdsArray = Array.from(uniqueItemIdsSet);

        this.setState({ purchasedContainers: uniqueItemIdsArray });
      })
      .catch(error => {
        console.error("Error fetching fiscal years:", error);
      });
  }
  


  fetchProductDescriptions() {
    axiosService.get('/defaultproducts/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const productdescriptions = filteredData.map(item => item.productdescription);
        this.setState({ productdescriptions: productdescriptions });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }

  fetchSapcodeNames() {
    axiosService.get('/defaultproducts/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const SapcodeNames = filteredData.map(item => item.sapcode);
  
        const sapcodeToProductDescriptionMap = {};
        filteredData.forEach(item => {
          sapcodeToProductDescriptionMap[item.sapcode] = item.productdescription;
        });
  
        this.setState({ SapcodeNames: SapcodeNames,SapcodeDescriptionNames:sapcodeToProductDescriptionMap  });
      })
      .catch(error => {
        console.error("Error fetching product sapcode:", error);
      });
  }

  findProductDescriptionForSapcode(sapcode) {
    const productDescriptionMap = this.state.SapcodeDescriptionNames;
    return productDescriptionMap[sapcode] || "Product not found";
  }


  fetchContainerIDS() {
    axiosService.get('/containers/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const ContainerIDs = filteredData.map(item => item.containerdescription);
  
        const conatinerIDToContainerDescriptionMap = {};
        filteredData.forEach(item => {
          conatinerIDToContainerDescriptionMap[item.containerdescription] = item.podelay;
        });
  
        this.setState({ containerIDs: ContainerIDs,containerDescriptionNames:conatinerIDToContainerDescriptionMap  });
      })
      .catch(error => {
        console.error("Error fetching container ids:", error);
      });
  }

  findContainerDescriptionForContainerID(containerdescription) {
    const containerDescriptionMap = this.state.containerDescriptionNames;
    return containerDescriptionMap[containerdescription] || "Container not found";
  }


  fetchPalletPoDelay() {
    axiosService.get('/palletpodelay/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const palletpodelayIDS = data.map(item => item.palletpodelayid);
  
        const palletPoDelayMap = {};
        data.forEach(item => {
          palletPoDelayMap[item.palletpodelayid] = item.palletpodelay;
        });
  
        this.setState({ palletpodelayids: palletpodelayIDS,palletpodelays:palletPoDelayMap  });
      })
      .catch(error => {
        console.error("Error fetching palletpo ids:", error);
      });
  }

  findPalletPoDelayID(palletpodelayid) {
    const palletPoDelayMap = this.state.palletpodelays;
    return palletPoDelayMap[palletpodelayid] || "palletpodelay not found";
  }


  fetchPalletIDS() {
    axiosService.get('/defaultproducts/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const PalletIDs = filteredData.map(item => item.sapcode);
  
        const palletIDToProductDescriptionMap = {};
        filteredData.forEach(item => {
          palletIDToProductDescriptionMap[item.sapcode] = item.productdescription;
        });
  
        this.setState({ palletIDs: PalletIDs,palletDescriptionNames:palletIDToProductDescriptionMap  });
      })
      .catch(error => {
        console.error("Error fetching product sapcode:", error);
      });
  }

  findPalletDescriptionForPalletID(sapcode) {
    const palletDescriptionMap = this.state.palletDescriptionNames;
    return palletDescriptionMap[sapcode] || "Product not found";
  }

  fetchContainerDescriptions() {
    axiosService.get('/containers/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const containerdescriptions = filteredData.map(item => item.containerdescription);
        this.setState({ containerdescriptions: containerdescriptions });
      })
      .catch(error => {
        console.error("Error fetching containers :", error);
      });
  }


  fetchPurchaseTypeNames() {
    axiosService.get('/purchasetypes/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const purchasetypeNames = data.map(item => item.purchasetypename);
        this.setState({ purchasetypeNames: purchasetypeNames });
      })
      .catch(error => {
        console.error("Error fetching purchasetypes :", error);
      });
  }


  fetchWarehouseNames() {
    axiosService.get('/warehouses/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const warehouseNames = filteredData.map(item => item.warehousename);
        this.setState({ warehouseNames: warehouseNames });
      })
      .catch(error => {
        console.error("Error fetching warehouse names:", error);
      });
  }

handleInput = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/;
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/[^0-9]/g, '');
    }
  };


  handlePurchaseTypeChange = (event) => {
    const purchasetypename = event.target.value;
    this.setState({ purchasetypename });

    if (purchasetypename === 'CONTAINER') {
      this.setState({ items: this.state.containersdescriptions });
    } else {
      this.setState({ items: this.state.productdescriptions });
    }
  };


  handleScrollRight = () => {
    this.setState((prevState) => ({
      currentYearIndex: Math.min(prevState.currentYearIndex + 1, prevState.fiscalYears.length - 1),
    }));
  };
  
  handleScrollLeft = () => {
    this.setState((prevState) => ({
      currentYearIndex: Math.max(prevState.currentYearIndex - 1, 0),
    }));
  };


componentDidMount(){
  this.refreshList();
  this.fetchContainerIDS();
  this.fetchPalletIDS();
  this.fetchPalletPoDelay();
}


// Function to reset the modal title
 resetModalTitle = () => {
  this.setState({ modalTitle: "Edit Purchase" });
};

// Use this function to open the modal
 openModal = () => {
  // Reset the modal title
  this.resetModalTitle();

  // ... any other logic you have to show the modal
};








render(){
  const {
      purchases,
      modalTitle,
      purchaseid,
      warehousename,
      fyname,
      purchasetypename,
      itempurchasedname,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      comment,
      loading,
      fiscalYears,
      currentYearIndex,
      currentYear,

      stockprocurement,


  }=this.state;




  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsWarehouses />

<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
      style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changePurchaseIdFilter}
      placeholder="Filter"/>

      </div>
      PurchaseId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      value={currentYear}
      placeholder="Filter"/>
      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changePurchaseTypeNameFilter}
      placeholder="Filter"/>
      </div>
      PurchaseType
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItempurchasedIDFilter}
      placeholder="Filter"/>
      </div>
      Itempurchased ID
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItempurchasedNameFilter}
      placeholder="Filter"/>
      </div>
      Itempurchased
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Satellite
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      LeadTime(months)
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>

</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {purchases.map(dep=> {

    let leadTime;
    if (dep.purchasetypeid===1) {
    leadTime = this.findContainerDescriptionForContainerID(dep.itempurchasedname);
    } else {
    leadTime = this.findPalletPoDelayID(1) || this.findPalletPoDelayID(2) || this.findPalletPoDelayID(3) || this.findPalletPoDelayID(4) ;
}
    const calculatedDateJuly = this.calculateDateFromFiscal(dep.year.fyname, 7, leadTime);
    const formattedJuly = this.formatCalculatedDate(calculatedDateJuly);
    const calculatedDateAugust = this.calculateDateFromFiscal(dep.year.fyname, 8, leadTime);
    const formattedAugust = this.formatCalculatedDate(calculatedDateAugust);
    const calculatedDateSeptember = this.calculateDateFromFiscal(dep.year.fyname, 9, leadTime);
    const formattedSeptember = this.formatCalculatedDate(calculatedDateSeptember);
    const calculatedDateOctober = this.calculateDateFromFiscal(dep.year.fyname, 10, leadTime);
    const formattedOctober = this.formatCalculatedDate(calculatedDateOctober);
    const calculatedDateNovember = this.calculateDateFromFiscal(dep.year.fyname, 11, leadTime);
    const formattedNovember = this.formatCalculatedDate(calculatedDateNovember);
    const calculatedDateDecember = this.calculateDateFromFiscal(dep.year.fyname, 12, leadTime);
    const formattedDecember = this.formatCalculatedDate(calculatedDateDecember);
    const calculatedDateJanuary = this.calculateDateFromFiscal(dep.year.fyname, 1, leadTime);
    const formattedJanuary = this.formatCalculatedDate(calculatedDateJanuary);
    const calculatedDateFebruary = this.calculateDateFromFiscal(dep.year.fyname, 2, leadTime);
    const formattedFebruary = this.formatCalculatedDate(calculatedDateFebruary);
    const calculatedDateMarch = this.calculateDateFromFiscal(dep.year.fyname, 3, leadTime);
    const formattedMarch  = this.formatCalculatedDate(calculatedDateMarch);
    const calculatedDateApril = this.calculateDateFromFiscal(dep.year.fyname, 4, leadTime);
    const formattedApril  = this.formatCalculatedDate(calculatedDateApril);
    const calculatedDateMay = this.calculateDateFromFiscal(dep.year.fyname, 5, leadTime);
    const formattedMay  = this.formatCalculatedDate(calculatedDateMay);
    const calculatedDateJune = this.calculateDateFromFiscal(dep.year.fyname, 6, leadTime);
    const formattedJune  = this.formatCalculatedDate(calculatedDateJune);

    // Get the current date
    const currentDate = new Date();

    // Extract month and year from the current date
    const currentMonth = currentDate.getMonth() + 1; // Adding 1 because months are zero-based
    const currentYear = currentDate.getFullYear();

    // Format the month/year string
    const formattedDate = `${currentMonth}/${currentYear}`;


    

  return (
      <tr key={dep.purchaseid} className="row-hover">
          <td className="table-text">{dep.purchaseid}</td>
          <td className="table-text">{dep.year?.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.warehouse?.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.purchasetype?.purchasetypename ?? 'N/A'}</td>
          <td className="table-text">{dep.sapcode ?? 'N/A'}</td>
          <td className="table-text">{dep.itempurchasedname ?? 'N/A'}</td>
          <td className="table-text">{dep.satellite ?? dep.product?.satellite ?? 'N/A'}</td>
          <td className="table-text">{leadTime}</td>
          <td className={`table-text ${dep.july ? (dep.povalidatedjuly ? 'text-success'   : (this.compareDates(formattedDate, formattedJuly) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.july ? (dep.povalidatedjuly ? "Po OK" : formattedJuly) : 'N/A'}</td>
          <td className={`table-text ${dep.august ? (dep.povalidatedaugust ? 'text-success'   : (this.compareDates(formattedDate, formattedAugust) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.august ? (dep.povalidatedaugust ? "Po OK" : formattedAugust) : 'N/A'}</td>
          <td className={`table-text ${dep.september ? (dep.povalidatedseptember ? 'text-success'   : (this.compareDates(formattedDate, formattedSeptember) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.september ? (dep.povalidatedseptember ? "Po OK" : formattedSeptember) : 'N/A'}</td>
          <td className={`table-text ${dep.october ? (dep.povalidatedoctober ? 'text-success'   : (this.compareDates(formattedDate, formattedOctober) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.october ? (dep.povalidatedoctober ? "Po OK" : formattedOctober) : 'N/A'}</td>
          <td className={`table-text ${dep.november ? (dep.povalidatednovember ? 'text-success'   : (this.compareDates(formattedDate, formattedNovember) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.november ? (dep.povalidatednovember ? "Po OK" : formattedNovember) : 'N/A'}</td>
          <td className={`table-text ${dep.december ? (dep.povalidateddecember ? 'text-success'   : (this.compareDates(formattedDate, formattedDecember) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.december ? (dep.povalidateddecember ? "Po OK" : formattedDecember) : 'N/A'}</td>
          <td className={`table-text ${dep.january ? (dep.povalidatedjanuary ? 'text-success'   : (this.compareDates(formattedDate, formattedJanuary) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.january ? (dep.povalidatedjanuary ? "Po OK" : formattedJanuary) : 'N/A'}</td>
          <td className={`table-text ${dep.february ? (dep.povalidatedfebruary ? 'text-success'   : (this.compareDates(formattedDate, formattedFebruary) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.february ? (dep.povalidatedfebruary ? "Po OK" : formattedFebruary) : 'N/A'}</td>
          <td className={`table-text ${dep.march ? (dep.povalidatedmarch ? 'text-success'   : (this.compareDates(formattedDate, formattedMarch) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.march ? (dep.povalidatedmarch ? "Po OK" : formattedMarch) : 'N/A'}</td>
          <td className={`table-text ${dep.april ? (dep.povalidatedapril ? 'text-success'   : (this.compareDates(formattedDate, formattedApril) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.april ? (dep.povalidatedapril ? "Po OK" : formattedApril) : 'N/A'}</td>
          <td className={`table-text ${dep.may ? (dep.povalidatedmay ? 'text-success'   : (this.compareDates(formattedDate, formattedMay) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.may ? (dep.povalidatedmay ? "Po OK" : formattedMay) : 'N/A'}</td>
          <td className={`table-text ${dep.june ? (dep.povalidatedjune ? 'text-success'   : (this.compareDates(formattedDate, formattedJune) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.june ? (dep.povalidatedjune ? "Po OK" : formattedJune) : 'N/A'}</td>
          <td className="table-text">

          </td>
      </tr>

);
   } )}
</tbody>
 )
}
</table>
</div>



</div>
  )
}
  }




